<template>
  <div class="floor-appraise floor">
    <div class="appraise-container">
      <h2 class="floor__h2">粉丝眼中的回收宝</h2>
      <hr class="floor__line">
      <p class="floor__desc">回收宝4年，900万+用户选择了回收宝，850万用户好评</p>
      <div class="swiper-box container">
        <div class="appraise-swiper swiper-container" v-swiper:swiper="swiperOption" ref="swiperContainer">
          <ul class="swiper-wrapper">
            <li class="item swiper-slide" v-for="(item, index) in commentList" :key="index">
              <div class="item-inner">
                <p class="item-content" v-text="item.comment"></p>
                <img class="item-icon" v-lazy="'https://www.huishoubao.com/static/pc/1001/img/avator/comment_'+item.img+'.jpg.jpg'">
                <p class="item-mobile" v-text="item.tel"></p>
                <p class="item-city">在{{ item.location }}，回收了{{ item.num }}台{{ item.type }}</p>
                <p class="item-date" v-text="item.date"></p>
              </div>
            </li>
          </ul>
        </div>
        <i class="swiper-button swiper-button-prev" @click="slidePrev"></i>
        <i class="swiper-button swiper-button-next" @click="slideNext"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';

if (process.env.VUE_ENV !== 'server') {
  require('swiper/dist/css/swiper.css');
  const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr');
  Vue.use(VueAwesomeSwiper);
}

export default {
  computed: {
    ...mapState({
      commentList: state => state.hsbComment.commentList
    })
  },
  data () {
    return {
      swiperOption: {
        slidesPerGroup: 4,
        slidesPerView: 4,
        spaceBetween: 10,
        observeParents: true,
        observer: true
      }
    };
  },
  mounted () {
  },
  methods: {
    slideNext () {
      this.swiper.slideNext();
    },
    slidePrev () {
      this.swiper.slidePrev();
    }
  }
};
</script>

<style lang="postcss" scoped>

@import 'config.css';

.appraise {
  &-container {
    margin: 0 auto;
    overflow: hidden;
  }
  &-swiper {
    height: 460px;
  }
}

.item {
  overflow: hidden;
  text-align: center;
  background-color: #fff;
  &-inner {
    height: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
  &-content {
    height: 140px;
    margin: 0 auto;
    margin-top: 50px;
    font-size: 14px;
    line-height: 1.2;
    color: #656b6f;
    text-align: center;
  }
  &-icon {
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }
  &-mobile {
    margin-top: 20px;
    color: #3b3d40;
    font-size: 12px;
    letter-spacing: 1px;
    font-weight: bold;
  }
  &-date,
  &-city {
    margin-top: 10px;
    font-size: 12px;
    color: #656b6f;
  }
}

.swiper {
  &-box {
    position: relative;
  }
  &-button {
    display: block;
    width: 20px;
    height: 48px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    background-color: #F3F4F7;
    background-image: none;
    &::after {
      border: 1px solid #666666;
      border-bottom-width: 0;
      border-left-width: 0;
      content: " ";
      top: 50%;
      right: 7px;
      position: absolute;
      width: 8px;
      height: 8px;
      border-color: #9a9b9b;
    }
    &:hover {
      &::after {
        border-color: $active-a-color;
      }
    }
  }
  &-button-next {
    right: -30px;
    &::after {
      transform: translateY(-50%) rotate(45deg);
      transform-origin: center center;
    }
  }
  &-button-prev {
    left: -30px;
    &::after {
      transform: translateY(-50%) rotate(-135deg);
      transform-origin: center center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/floor-appraise.vue